import { useRef } from "react";
import { type Dispatch, type SetStateAction } from "react";
import { BadgeV2 } from "./badges/Badge";
import { badgeColors } from "./badges/utils";

type Props = {
  tags: string[];
  setTags: (tags: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
  badgeColor?: (typeof badgeColors)[number];
  searchText?: string;
  setSearchText?: Dispatch<SetStateAction<string>>;
  onRemove?: (tag: string) => void;
};

export const TagsInput = (props: Props) => {
  const {
    tags,
    setTags,
    placeholder,
    disabled,
    badgeColor,
    searchText,
    setSearchText,
    onRemove,
  } = props;

  // ----------------------------- DATA -----------------------------

  const inputRef = useRef<HTMLInputElement>(null);

  // ----------------------------- METHODS -----------------------------

  const removeTag = (index: number) => {
    if (disabled) return;
    if (onRemove) {
      onRemove(tags[index])
    } else {
      setTags(tags.filter((_, i) => i !== index));
    }
  };

  // ----------------------------- RENDER -----------------------------

  return (
    <div
      className="v2 tags-input"
      onClick={(e) => {
        // If the clicked element is not an input or tag, focus the input
        if (e.target === e.currentTarget) {
          inputRef.current?.focus();
        }
      }}
    >
      {tags.map((tag, index) => (
        <BadgeV2
          key={index}
          name={tag}
          color={badgeColor}
          onClose={() => {
            removeTag(index);
          }}
        />
      ))}

      <input
        type="text"
        disabled={disabled}
        ref={inputRef}
        value={searchText}
        onChange={(e) => {
          if (setSearchText) {
            setSearchText(e.target.value);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (setSearchText) {
              setSearchText("");
            }
            if (inputRef.current && inputRef.current.value) {
              setTags([...tags, inputRef.current.value]);
              inputRef.current.value = "";
            }
          }
        }}
        placeholder={placeholder}
      />
    </div>
  );
};
